import currency from "currency.js";

type SupportedCurrencies = "USD" | "EUR" | "GBP" | "AUD";

const SYMBOLS: Record<SupportedCurrencies, string> = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  AUD: "A$",
};

export function formatCurrencyFromCents(
  amountCents: number,
  currencyCode: string | null | undefined
): string {
  const code = (currencyCode?.toUpperCase() || "USD") as SupportedCurrencies;
  const symbol = SYMBOLS[code] || "$";

  return currency(amountCents, {
    fromCents: true,
    symbol,
    separator: ",",
    precision: 2,
  }).format();
}
